import { useState } from 'react'
import Iframe from 'react-iframe'
import { useTranslation } from 'react-i18next'

import Sidebar from './Sidebar'
import Topbar from './Topbar'

export const DashboardTrade = () => {
  const { t } = useTranslation()
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  return (
    <div
      className="relative flex min-h-screen w-full"
      data-testid="container-dashboard-trade-container"
    >
      <Topbar />
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      {isSidebarOpen && (
        <div
          onClick={toggleSidebar}
          className="fixed inset-0 bg-black opacity-50 z-20"
          data-testid="nav-overlay"
        ></div>
      )}
      <div
        className={`flex-grow dark:bg-pebble flex flex-col transition-all duration-300 ${isSidebarOpen ? 'z-10' : ''}`}
        data-testid="container-content-wrapper"
      >
        <div
          className="flex-grow flex justify-center items-start"
          data-testid="container-content-container"
        >
          <div
            className="w-full max-w-[1400px] mx-auto mt-24 lg:mt-12"
            data-testid="container-iframe-container"
          >
            <h1
              className="text-3xl font-normal mb-4 text-black dark:text-white text-left lg:pt-12 ml-4"
              data-testid="container-title"
            >
              {t('dashboardTrade.title')}
            </h1>
            <Iframe
              url={import.meta.env.VITE_APPLICATION_URL}
              styles={{ width: '100%', height: '80vh' }}
              className=""
              display="block"
              allow="camera"
              target="_top"
              data-testid="container-iframe"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardTrade

/*
POTENTIAL IMPROVEMENTS:
1. Add loading state for the iframe
2. Implement error handling if the iframe fails to load
3. Add fallback content if the application URL is not available
4. Consider implementing responsive sizing based on viewport
5. Add proper keyboard navigation and focus management
6. Consider adding a resize handle for the iframe
7. Add proper screen reader announcements for iframe content
8. Consider implementing messaging between the parent and iframe for better integration
9. Add proper error boundaries for catching rendering errors
*/
